import { render, staticRenderFns } from "./rectifications.vue?vue&type=template&id=a36d1842"
import script from "./rectifications.vue?vue&type=script&lang=js"
export * from "./rectifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports